(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delaceys-header"]) return;
  try {
    
  const root = document.querySelector('.delaceys-demo');
  if (root) {
    const searchButton = root.querySelector('.native-search-toggle');
    const searchForm = root.querySelector('#delaceys-header-search');

    const dialog = root.querySelector('#delaceys-mobile-menu');
    const menuButton = root.querySelector('.mobile-menu-button');
    menuButton?.addEventListener('click', () => { dialog.showModal(); menuButton.setAttribute('aria-expanded', 'true'); });
    dialog?.querySelector('.drawer-close')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog || event.target.closest('a')) dialog.close(); });
    dialog?.addEventListener('close', () => menuButton.setAttribute('aria-expanded', 'false'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
